module.exports = __webpack_public_path__ + "static/media/trimex_Suprema S.0b289a96.png";